<mat-card class="content-card">

    <h3>Card Creation Batches</h3>






<span (click)="returnBack()" style="cursor: pointer">◀️ Go back</span>

<app-mat-table-generator #table
                         tableName="createCardTable"
                         [useEmbededFilter]="false"
                         [columns]="columns"
                         [dataSource]="dataSource"
                         [editEnabled]="editEnabled()"
                         [deleteEnabled]="deleteEnabled()"
                         [multiselectEnabled]="multiselectEnabled()"
                         [viewLink]="getViewLink"
                         [editLink]="getEditLink"
                         [customActions]="createBatchCustomActions"
                         [dialogRemoveText]="dialogRemoveText"
                         [saveFilters]=true


>
</app-mat-table-generator>
</mat-card>
